export default "__VITE_ASSET__fd83c995__"